const dashboard = {
  collectedToday: 'Collected today',
  declinedPayments: 'Declined payments',
  unpaidDonations: 'Unpaid invoices',
  scheduled: 'Scheduled',
  events: 'Events',
  payments: 'payments',
  paymentsToReview: 'payments to review',
  pledges: 'pledges',
  paymentsToCome: 'payments to come this month',
  activeCampaigns: 'active campaigns',
  versusYesterday: 'vs yesterday',
  oldestDays: 'oldest',
  days: 'days',
  donor: 'Donor',
  payment: 'Payment ID',
  date: 'Date',
  reason: 'Reason',
  amount: 'Amount',
  actions: 'Actions',
  edit: 'Edit',
  retry: 'Retry',
  downloadCsv: 'Download CSV',
  dueDate: 'Due date',
  endDate: 'End date',
  daysOverdue: 'Days overdue',
  sendInvoice: 'Send invoice',
  downloadInvoice: 'Download PDF',
  sendTaxReceipt: 'Send tax receipt',
  downloadTaxReceipt: 'Download tax receipt',
  scheduledPayments: 'Scheduled payments',
  scheduledDate: 'Scheduled date',
  paymentMethod: 'Payment method',
  periodAll: 'All',
  periodToday: 'Today',
  periodLastWeek: 'Last week',
  periodLastMonth: 'Last month',
  periodThisWeek: 'This week',
  periodMonth: 'This month',
  periodTomorrow: 'Tomorrow',
  fundraisingEvents: 'Fundraising',
  goal: 'Goal',
  eventsCount: 'events',
  eventPage: 'Page',
  of: 'of',
  recentPayments: 'Recent payments',
  topDonors: 'Top donors this year',
  gifts: 'donations',
  filter: 'Filter by name, company or title…',
};

export default dashboard;
